import { stringRequired } from '../../utils/validations';
import { ConditionItemType } from '../types';
import { ChecklistCompletedOrNotCompletedConditionType } from './types';

export function useChecklistCompletedOrNotCompletedCondition() {
	return {
		validate: (values: ChecklistCompletedOrNotCompletedConditionType): {
			hasError: () => boolean;
			errors: {
				field: string | null;
			}
		} => {
			let hasErrors = false;
			const validations = {
				field: [
					stringRequired(values.field, 'This field is required'),
				],
			};

			const getError = (validation: Array<string | undefined>) => {
				const foundError = validation.find(item => item !== undefined) || null;
				if (foundError) {
					hasErrors = true;
				}

				return foundError || null;
			};

			return {
				hasError: () => hasErrors,
				errors: {
					field: getError(validations.field),
				}
			};
		},
		getValues: (type: 'check-list-is-completed' | 'check-list-is-not-completed', data: ChecklistCompletedOrNotCompletedConditionType): { type: string; data: { field: string } } => {
			return {
				type: type,
				data: {
					field: data.field,
				}
			};
		},
		loadValues: (data: ChecklistCompletedOrNotCompletedConditionType): ChecklistCompletedOrNotCompletedConditionType => {
			return {
				field: data.field,
			};
		},
		setCondition: (input: {
			conditionId: string;
			setConditions: React.Dispatch<React.SetStateAction<Array<ConditionItemType>>>;
			condition: string;
		}) => {
			input.setConditions(oldConditions => {
				const others = oldConditions.filter(item => item.id !== input.conditionId) as ConditionItemType[];
				const current = oldConditions.find(item => item.id === input.conditionId) as ConditionItemType;

				return [
					...others, {
						...current,
						fieldMeetCertainCriteria: null,
						condition: input.condition,
						checklistCompletedOrNotCompletedCondition: {
							field: '',
						}
					}
				];
			});
		}
	};
}